module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Regular-3b88e6f1bce08dd7f5395a17ff471f42.woff";